import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

const style = {
    bgcolor: 'background.paper',
    boxShadow: 24,
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
};

interface BasicModalProps {
    children?: ReactNode;
    disableCloseButton?: boolean;
    disableCloseClick?: boolean;
    handleClose?: () => void;
    keepMounted?: boolean;
    open: boolean;
    title?: string;
}

export default function BasicModal(props: Readonly<BasicModalProps>) {
    const { children, disableCloseButton, disableCloseClick, handleClose, keepMounted, open, title } = props;

    return (
        <Modal keepMounted={keepMounted ?? false} onClose={!disableCloseClick ? handleClose : undefined} open={open}>
            <Box sx={style}>
                {title ? (
                    <Stack
                        direction="row"
                        sx={{
                            alignItems: 'center',
                            height: 60,
                            justifyContent: 'space-between',
                            paddingLeft: 'var(--safe-area-inset-left, 0px)',
                            paddingRight: 'var(--safe-area-inset-right, 0px)',
                            paddingTop: 'var(--safe-area-inset-top, 0px)',
                            px: 2,
                        }}
                    >
                        <Typography color="primary" component="h2" variant="h6">
                            {title}
                        </Typography>
                        {!disableCloseButton && (
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        )}
                    </Stack>
                ) : null}
                {children}
            </Box>
        </Modal>
    );
}
